import { createApp } from "vue";

//第三方库
import Cookies from "js-cookie";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import locale from "element-plus/es/locale/lang/zh-cn";

// 全局样式
import "@/assets/styles/index.scss";
import "virtual:svg-icons-register";
import "virtual:windi.css";

//插件工具
import { useI18n } from "@/plugins/i18n";
import directive from "./directive"; // 注册指令
import plugins from "./plugins";
import { download } from "@/utils/request";

//工具函数
import { useDict } from "@/utils/dict";
import {
  parseTime,
  resetForm,
  addDateRange,
  handleTree,
  selectDictLabel,
  selectDictLabels,
} from "@/utils/cems";

//全局组件
import SvgIcon from "@/components/SvgIcon";
import elementIcons from "@/components/SvgIcon/svgicon";
// 分页组件
import Pagination from "@/components/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/RightToolbar";
// 富文本组件
import Editor from "@/components/Editor";
// 文件上传组件
import FileUpload from "@/components/FileUpload";
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview";
// 字典标签组件
import DictTag from "@/components/DictTag";
// 弹窗二次封装组件
import ReDialog from "@/components/ReDialog";
// 查询表单，新增表单，表格组件
import FormRule from "@/components/FormRule";
import FormSearch from "@/components/FormSearch";
import FormRuleComponent from "@/components/FormRule/install";
import FormComponent from "@/components/FormSearch/install";
import CommonTable from "@/components/Table";
import TableComponent from "@/components/Table/install";
import ListWrap from "@/components/ListWrap";

import App from "./App";
const app = createApp(App);

// 全局方法挂载
app.config.globalProperties.useDict = useDict;
app.config.globalProperties.download = download;
app.config.globalProperties.parseTime = parseTime;
app.config.globalProperties.resetForm = resetForm;
app.config.globalProperties.handleTree = handleTree;
app.config.globalProperties.addDateRange = addDateRange;
app.config.globalProperties.selectDictLabel = selectDictLabel;
app.config.globalProperties.selectDictLabels = selectDictLabels;
app.config.globalProperties.$isEN= Cookies.get("lang") =='en',

// 全局组件挂载
app.component("DictTag", DictTag);
app.component("Pagination", Pagination);
app.component("FileUpload", FileUpload);
app.component("ImageUpload", ImageUpload);
app.component("ImagePreview", ImagePreview);
app.component("RightToolbar", RightToolbar);
app.component("Editor", Editor);
app.component("ReDialog", ReDialog);
app.component("svg-icon", SvgIcon);
app.component("FormRule", FormRule);
app.component("FormSearch", FormSearch);
app.component("CommonTable", CommonTable);
app.component("ListWrap", ListWrap);


import store from "./store";
import router from "./router";
app.use(router);
app.use(store);
app.use(plugins);
app.use(elementIcons).use(useI18n);
app
  // .use(CommonTable)
  .use(TableComponent)
  .use(FormRuleComponent)
  .use(FormComponent);
// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: locale,
  // 支持 large、default、small
  size: Cookies.get("size") || "default",
});

directive(app);

app.mount("#app");
